const { Flex, FlexItem, FlexBlock, RangeControl, Button, ButtonGroup} = wp.components;
const { __ } = wp.i18n;

export const WidthSize = ({field, onChange} = props)=>{
  
    const {size, unit} = field;
    const maxVal = () =>{
        return unit == "%" ? 100 : 500;
		 }
		 const minVal = () =>{
			return unit == "%" ? 5 : 50;
	 }
    return (
        <>
        <Flex>
					<FlexItem>{__('Width', 'themesfirst')}</FlexItem>
					<FlexBlock className="tf-text-align-end">
					<ButtonGroup size="small" aria-label="small outlined button group" style={{marginLeft:"auto"}}>
						<Button onClick={()=> onChange({...field, unit : '%', size : 60 })} isPrimary={unit == "%"} isSmall>%</Button>
						<Button onClick={()=> onChange({...field, unit : 'px', size: 300})} isPrimary={unit != "%"} isSmall>px</Button>
					</ButtonGroup>
					</FlexBlock>
        </Flex> 
				<Flex>
					<FlexBlock>
						<RangeControl
						label={ size + unit} 
						withInputField = {true}
						value={ size }
						onChange={ ( obj ) => onChange({...field, size  : obj})}
						min={ minVal() }	
						step ={1}			
						max={maxVal()}  
					/>
		</FlexBlock>
				</Flex>
      </>
    );

}